import { makeAutoObservable } from 'mobx';
import {EarningsFormatter} from 'shared/tools';

class CommissionFormState {
  model;
  errors = {};
  earningsFormatter;

  constructor() {
    makeAutoObservable(this);
  }

  receiveProps({model, errors}) {
    this.model = model;
    this.errors = errors || {};
    this.earningsFormatter = new EarningsFormatter(model);
  }
}

export default CommissionFormState;
